import React from 'react';
import {
  HandlerStateChangeEvent,
  PanGestureHandler,
  PanGestureHandlerEventPayload,
  State,
} from 'react-native-gesture-handler';

import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setCaretPosition} from '../../store/slices/editor';
import {Animated, useWindowDimensions, View} from 'react-native';

function EditorCaret() {
  const dispatch = useAppDispatch();
  const caretPosition = useAppSelector(
    state => state.editor.caretPosition,
  );
  const {width, height} = useWindowDimensions();
  const translateX = new Animated.Value(0);
  const onGestureEvent = Animated.event(
    [
      {
        nativeEvent: {
          translationX: translateX,
        },
      },
    ],
    {
      listener: event => {
        // console.info('ongesture', event)
      },
      useNativeDriver: true,
    },
  );

  const onHandlerStateChange = (
    event: HandlerStateChangeEvent<PanGestureHandlerEventPayload>,
  ): number | undefined => {
    if (event.nativeEvent.oldState === State.ACTIVE) {
      const newOffset = event.nativeEvent.translationX;
      let fullOffset = caretPosition + newOffset;
      if (fullOffset < 0) fullOffset = 0;

      translateX.setOffset(fullOffset);
      translateX.setValue(0);
      dispatch(setCaretPosition(fullOffset));
      return fullOffset;
    }
  };
  return (
    <View style={{cursor: 'pointer', height: 0}}>
      <PanGestureHandler
        onGestureEvent={onGestureEvent}
        onHandlerStateChange={onHandlerStateChange}>
        <Animated.View
          style={[
            {
              width: 30,
              opacity: 0.5,
              height: height / 2,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'red',
              cursor: 'pointer',
            },
            {
              transform: [
                {
                  translateX: translateX.interpolate({
                    inputRange: [0, width],
                    outputRange: [caretPosition, width],
                    extrapolate: 'extend',
                  }),
                },
              ],
            },
          ]}></Animated.View>
      </PanGestureHandler>
    </View>
  );
}
export default EditorCaret;
